<template>
	<div class="common-alarm-page">
		<gc-header header-data="commonAlarm" />
		<div class="content">
			<ConfigList
				v-model="selectedItem"
				:selectedItem="selectedItem"
				:list="configList"
				class="content-left"
				@click="handleClick"
			/>
			<ConfigPanel
				class="content-right"
				:title="selectedItem.label"
				:id="selectedItem.value"
				:event-name="selectedItem.eventName"
				:show-comparison="selectedItem.showComparison"
				:classification="selectedItem.classification"
				:event-expression="selectedItem.eventExpression"
				@update="handleUpdate"
			/>
		</div>
	</div>
</template>

<script>
import { apiGetCommonAlarmConfig } from '@/apis/waterAlarmConfig.api'
import ConfigList from '../components/ConfigList.vue'
import ConfigPanel from './config-panel/index.vue'

export default {
	name: 'CommonAlarm',
	provide() {
		return {
			getComparison: () => this.selectedItem,
		}
	},
	components: {
		ConfigList,
		ConfigPanel,
	},
	data() {
		return {
			selectedItem: {},
			configList: [],
		}
	},
	activated() {
		this.initConfigList()
	},
	methods: {
		handleClick(item) {
			this.selectedItem = item
		},
		handleUpdate() {
			this.initConfigList()
		},
		async initConfigList() {
			const res = await this.getConfigList()
			const list = this.dealRes(res)
			this.configList = list
			this.handleClick(this.selectedItem.value ? this.selectedItem : list[0])
		},
		dealRes(list) {
			return list.map(item => ({
				label: item.eventName,
				value: item.eventId,
				number: item.total,
				classification: item.classification,
				eventName: item.eventName,
				eventExpression: item.eventExpression,
				comparisonName: item.comparisonName,
				comparisonUnit: item.comparisonUnit,
				showComparison: !!item.comparisonName,
			}))
		},
		getConfigList() {
			return apiGetCommonAlarmConfig({ alarmSource: '2' })
				.then(res => res)
				.catch(() => [])
		},
	},
}
</script>

<style scoped lang="scss">
.common-alarm-page {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.content {
	flex: 1;
	display: flex;
	overflow: hidden;
}
.content-left {
	width: 360px;
	height: 100%;
	padding: 25px;
	border-right: 1px dashed #f1f1f1;
}

.content-right {
	flex: 1;
}
</style>
